module.exports = __webpack_public_path__ + "static/media/3.2512bf53.jpg";